import { getAccountName } from '../Utils/UserFunctions';

/**
 * Returns validator for Client Locator field.
 * 
 * @param {string} key the account name.
 * @returns {object} the validator.
 */
export function getPalette() {
    //const accountName = getAccountName().toLowerCase();

    //let palette = null;
    //try {
    //palette = require('./AppPalette.' + accountName);
    //} catch (error) {
    let palette = require('./AppPalette.default');
    //}

    return palette;
}


// WEBPACK FOOTER //
// ./src/components/AppPalette/AppPaletteFactory.js